import _slicedToArray from '@babel/runtime-corejs3/helpers/esm/slicedToArray';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/esm/toConsumableArray';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _Array$from from '@babel/runtime-corejs3/core-js-stable/array/from';
import _startsWithInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/starts-with';
import _Map from '@babel/runtime-corejs3/core-js-stable/map';
import _Object$entries from '@babel/runtime-corejs3/core-js-stable/object/entries';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import moment from 'moment-timezone';
import { parseTime } from '@commercetools-uikit/utils';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';

var _en, _de, _es, _fr, _ja, _zhCN; // Reference: https://momentjs.com/docs/#/displaying/format/


var formatToken = {
  D: 'D',
  // NUMERIC_SINGLE_DAY
  DD: 'DD',
  // NUMERIC_TWO_DIGITS_DAY
  M: 'M',
  // NUMERIC_SINGLE_MONTH
  MM: 'MM',
  // NUMERIC_TWO_DIGIT_MONTH
  YY: 'YY',
  // TWO_DIGITS_YEAR
  YYYY: 'YYYY',
  // FOUR_DIGITS_YEAR
  h: 'h',
  // HOUR_12_SINGLE
  hh: 'hh',
  // HOUR_12_TWO_DIGITS
  H: 'H',
  // HOUR_24_SINGLE
  HH: 'HH',
  // HOUR_24_TWO_DIGITS
  m: 'm',
  // MINUTE_SINGLE
  mm: 'mm',
  // MINUTE_TWO_DIGITS
  A: 'A' // PERIOD - https://unicode.org/reports/tr35/tr35-6.html#Date_Format_Patterns

}; // Here is where we translate from the standard characters used in the pattern
// (calculated in the moment.js library) to the characters used in the locale
// We just need to provide the translation for the characters that are different
// For instance, in english we don't need to translate date characters as
// they are the same as the pattern characters

var DATE_FORMAT_LOCALIZED_MAPPINGS = {
  en: (_en = {}, _defineProperty(_en, formatToken.h, 'HH'), _defineProperty(_en, formatToken.A, 'AM/PM'), _en),
  de: (_de = {}, _defineProperty(_de, formatToken.DD, 'TT'), _defineProperty(_de, formatToken.YYYY, 'JJJJ'), _defineProperty(_de, formatToken.HH, 'SS'), _de),
  es: (_es = {}, _defineProperty(_es, formatToken.H, 'HH'), _defineProperty(_es, formatToken.YYYY, 'AAAA'), _es),
  fr: (_fr = {}, _defineProperty(_fr, formatToken.DD, 'JJ'), _defineProperty(_fr, formatToken.YYYY, 'AAAA'), _fr),
  ja: (_ja = {}, _defineProperty(_ja, formatToken.HH, '午前/午後 時'), _defineProperty(_ja, formatToken.mm, '分'), _defineProperty(_ja, formatToken.DD, '日'), _defineProperty(_ja, formatToken.MM, '月'), _defineProperty(_ja, formatToken.YYYY, '年'), _ja),
  'zh-CN': (_zhCN = {}, _defineProperty(_zhCN, formatToken.HH, '小时'), _defineProperty(_zhCN, formatToken.mm, '分钟'), _defineProperty(_zhCN, formatToken.DD, '日'), _defineProperty(_zhCN, formatToken.MM, '月'), _defineProperty(_zhCN, formatToken.YYYY, '年'), _zhCN)
};

var getDaysInMonth = function getDaysInMonth(day, timeZone) {
  return moment.tz(day, timeZone).daysInMonth();
};

var changeDateInMonth = function changeDateInMonth(day, timeZone, dayOfMonth) {
  return moment.tz(day, timeZone).date(dayOfMonth).toISOString();
};

var changeTime = function changeTime(dateString, timeZone, parsedTime) {
  var date = moment.tz(dateString, timeZone);
  date.hours(parsedTime.hours);
  date.minutes(parsedTime.minutes);
  date.seconds(parsedTime.seconds);
  date.seconds(parsedTime.seconds);
  date.milliseconds(parsedTime.milliseconds);
  return date.toISOString();
};

var getPreviousDay = function getPreviousDay(day) {
  return moment(day).subtract(1, 'day').format('YYYY-MM-DD');
};

var formatTime = function formatTime(day, locale, timeZone) {
  var date = moment.tz(day, timeZone).locale(locale);
  if (date.milliseconds()) return date.format('HH:mm:ss.SSS');
  if (date.seconds()) return date.format('LTS'); // 5:13:51 PM

  return date.format('LT'); // 5:13 PM
};

var formatDate = function formatDate(day, locale, timeZone) {
  var _context;

  var date = moment(day, moment.ISO_8601, locale).tz(timeZone).format('L');
  var time = formatTime(day, locale, timeZone);
  return _concatInstanceProperty(_context = "".concat(date, " ")).call(_context, time);
};

var getDateInMonth = function getDateInMonth(day, timeZone) {
  return moment.tz(day, timeZone).date();
};

var getToday = function getToday(timeZone) {
  return moment.tz(timeZone).startOf('day').toISOString();
};

var changeMonth = function changeMonth(day, timeZone, delta) {
  return moment.tz(day, timeZone).add(delta, 'month').toISOString();
};

var getPaddingDayCount = function getPaddingDayCount(day, locale, timeZone) {
  var firstDayOfWeek = moment.localeData(locale).firstDayOfWeek();
  var firstDayOfMonth = moment.tz(day, timeZone).startOf('month').day(); // ensure number is always positive

  return (firstDayOfMonth - firstDayOfWeek + 7) % 7;
};

var getWeekdayNames = function getWeekdayNames(locale) {
  var _context2;

  var weekDays = moment.localeData(locale).weekdaysMin();
  var firstDay = moment.localeData(locale).firstDayOfWeek();
  return _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(_sliceInstanceProperty(weekDays).call(weekDays, firstDay)), _toConsumableArray(_sliceInstanceProperty(weekDays).call(weekDays, 0, firstDay)));
};

var getStartOf = function getStartOf(day, timeZone) {
  return moment.tz(day, timeZone).startOf('day').toISOString();
};

var getMonthCalendarLabel = function getMonthCalendarLabel(day, locale) {
  return moment(day, moment.ISO_8601, locale).format('MMMM');
};

var getYearCalendarLabel = function getYearCalendarLabel(day, locale) {
  return moment(day, moment.ISO_8601, locale).format('YYYY');
};

var isSameDay = function isSameDay(a, b) {
  return moment(a).isSame(b, 'day');
};

var getCalendarDayLabel = function getCalendarDayLabel(day, timeZone) {
  return moment.tz(day, timeZone).format('D');
};

var createItemDateTimeToString = function createItemDateTimeToString(locale, timeZone) {
  return function (item) {
    return item ? formatDate(item, locale, timeZone) : '';
  };
};

var createCalendarItems = function createCalendarItems(day, timeString, timeZone) {
  var _context3;

  var parsedTime = parseTime(timeString);
  return _mapInstanceProperty(_context3 = _Array$from({
    length: getDaysInMonth(day, timeZone)
  })).call(_context3, function (_, i) {
    var dayOfMonth = i + 1;
    var date = changeDateInMonth(day, timeZone, dayOfMonth);

    if (parsedTime) {
      date = changeTime(date, timeZone, parsedTime);
    }

    return date;
  });
};

var createSuggestedItems = function createSuggestedItems(inputValue, timeZone) {
  if (_startsWithInstanceProperty(inputValue).call(inputValue, 't')) return [getToday(timeZone)];
  return [];
};

var parseInputText = function parseInputText(text, locale, timeZone) {
  var parts = text.split(' ');
  var dateString = parts[0];

  var timeString = _sliceInstanceProperty(parts).call(parts, 1).join(' ');

  if (!dateString) return '';
  var date = moment.tz(dateString, moment.localeData(locale).longDateFormat('L'), timeZone);
  if (!date.isValid()) return ''; // enable parsing a date only

  if (!timeString) return date.startOf('day').toISOString();
  var parsedTime = parseTime(timeString);

  if (parsedTime) {
    date.hours(parsedTime.hours);
    date.minutes(parsedTime.minutes);
    date.seconds(parsedTime.seconds);
    date.seconds(parsedTime.seconds);
    date.milliseconds(parsedTime.milliseconds);
    return date.toISOString();
  }

  return '';
};

var localizedDateFormatPatternCache = new _Map();

var getLocalizedDateTimeFormatPattern = function getLocalizedDateTimeFormatPattern(locale) {
  var _context4, _context5;

  var formatType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'date';

  var key = _concatInstanceProperty(_context4 = "".concat(locale, "::")).call(_context4, formatType);

  if (localizedDateFormatPatternCache.has(key)) {
    return localizedDateFormatPatternCache.get(key);
  } // References:
  //  https://momentjs.com/docs/#/i18n/locale-data/
  //  https://momentjs.com/docs/#/displaying/ ("Localized formats" section)


  var localeData = moment().locale(locale).localeData();
  var localizedFormat = '';

  switch (formatType) {
    case 'date':
      localizedFormat = localeData.longDateFormat('L');
      break;

    case 'time':
      localizedFormat = localeData.longDateFormat('LT');
      break;

    case 'full':
      localizedFormat = _concatInstanceProperty(_context5 = "".concat(localeData.longDateFormat('L'), " - ")).call(_context5, localeData.longDateFormat('LT'));
      break;

    default:
      throw new Error("CalendarTime.getLocalizedDateTimeFormatPattern: Unknown format type '".concat(formatType, "'"));
  } // We try to get the localization both with the whole locale (e.g. 'en-GB')
  // and the generic language code (e.g. 'en').


  var _locale$split = locale.split('-'),
      _locale$split2 = _slicedToArray(_locale$split, 1),
      languageCode = _locale$split2[0];

  var localeMappings = _Object$entries(DATE_FORMAT_LOCALIZED_MAPPINGS[locale] || DATE_FORMAT_LOCALIZED_MAPPINGS[languageCode] || {}); // In case we don't have a translation for the locale, we fallback to the
  // pattern from the moment locale data.


  var pattern = localizedFormat;

  if (localeMappings && localeMappings.length > 0) {
    pattern = _reduceInstanceProperty(localeMappings).call(localeMappings, function (localizedPattern, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          token = _ref2[0],
          mappedValue = _ref2[1];

      return localizedPattern.replace(token, mappedValue);
    }, localizedFormat);
  }

  localizedDateFormatPatternCache.set(key, pattern);
  return pattern;
}; // NOTE: This string will be replaced on build time with the package version.


var version = "15.0.2";
export { changeDateInMonth, changeMonth, changeTime, createCalendarItems, createItemDateTimeToString, createSuggestedItems, formatDate, formatTime, getCalendarDayLabel, getDateInMonth, getDaysInMonth, getLocalizedDateTimeFormatPattern, getMonthCalendarLabel, getPaddingDayCount, getPreviousDay, getStartOf, getToday, getWeekdayNames, getYearCalendarLabel, isSameDay, parseInputText, version };